import { NgModule } from '@angular/core';
import { PathwaysComponent } from './pathways.component/pathways.component';
import { PathwaysService } from '@ispm-client/modules/pathways/services/pathways.service';
import { CurationInfoForPathwaysEffects } from '@ispm-client/modules/pathways/store/effects/curation-info-for-pathways.effects';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ProcessExecutorModule } from '@ispm-client/modules/process-executor';
import { environment } from '../../environments/environment';
import { PathwaysBackendMockModule } from '@ispm-client/modules/backend-mock-modules/pathways-backend-mock/pathways-backend-mock.module';
import { PatientModule } from '@ispm-client/modules/patient';
import { PathwaysPanelComponent } from './pathways-panel.component/pathways-panel.component';
import { WidgetsModule } from '@ispm/widgets/widgets.module';
import { SharedModule } from '@ispm/shared/shared.module';
import { CompletePathwaySelectionEffects, LoadPathwaysEffects, PathwayTestEffects } from './store/effects';
import { PathwaysConfigurationService } from './services';
import { metaReducers, pathwaysMetaReducerA } from '@ispm-client/modules/pathways/store/reducers';
import { DynamicFormModule } from '@ispm/shared/dynamic-form/dynamic-form.module';
import { AgregationService } from '../aggregator/services';
import { StepConfirmationButtonComponent } from './step-confirmation-button/step-confirmation-button.component';
import { PathwayConfirmStepService } from './services/pathway-confirm-step.service';


@NgModule({
  declarations: [
    PathwaysComponent,
    PathwaysPanelComponent,
    StepConfirmationButtonComponent
  ],
  imports: [
    // PatientModule,
    ProcessExecutorModule,
    SharedModule,
    WidgetsModule,
    StoreModule.forFeature('Pathways', pathwaysMetaReducerA, { metaReducers }),
    environment.production ? [] : PathwaysBackendMockModule.forRoot(),
    EffectsModule.forFeature([LoadPathwaysEffects, CurationInfoForPathwaysEffects, PathwayTestEffects, CompletePathwaySelectionEffects]),
    DynamicFormModule
  ],
  exports: [
    PathwaysComponent,
    StepConfirmationButtonComponent
  ]
})
export class PathwaysModule {
  public static forRoot() {
    return {
      providers: [PathwaysService, PathwaysConfigurationService, AgregationService, PathwayConfirmStepService],
      ngModule: PathwaysModule,
    };
  }
}
